import { useAuthStore } from '../store/authStore.js';

/**
 * Derive the current subscription state from the auth store.
 * Returns a flat object the dashboard, banner, and pricing page can read.
 */
export function useSubscription() {
  const user = useAuthStore((s) => s.user);

  const tier = user?.tier || 'BASIC';
  const status = user?.subscriptionStatus || 'INACTIVE';
  const endsAt = user?.subscriptionEndsAt ? new Date(user.subscriptionEndsAt) : null;
  const isActive = status === 'ACTIVE' && endsAt && new Date() < endsAt;
  const isExpired = status === 'EXPIRED';
  const isInactive = !isActive && !isExpired;

  const daysLeft = endsAt
    ? Math.max(0, Math.ceil((endsAt.getTime() - Date.now()) / 86_400_000))
    : 0;

  const endsAtLabel = endsAt
    ? endsAt.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return {
    tier,
    status,
    isActive,
    isExpired,
    isInactive,
    daysLeft,
    endsAt,
    endsAtLabel
  };
}
